import axios from 'axios';

import history from './history';
import config from '../config';

import UserAPI from './UserAPI';

const apiPath = config.api.positions;

function url(...rest) {
  return rest.map(val => `${val}`.replace(/\/$/, '')).join('/');
}

class PositionAPI {
  static get() {
    return axios({
      method: 'get',
      url: apiPath,
      responseType: 'json',
      //TODO: Remove auth eventually 
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }
}

export default PositionAPI;
